/**
 * Safely extracts error message from API response
 * Handles FastAPI/Pydantic validation error arrays
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  // Handle FastAPI/Pydantic validation error arrays
  if (Array.isArray(detail) && detail.length > 0) {
    // Extract the first error's message
    const firstError = detail[0];
    if (typeof firstError === 'object' && firstError.msg) {
      return firstError.msg;
    }
    if (typeof firstError === 'string') {
      return firstError;
    }
    return defaultMessage;
  }
  
  // Handle object with msg property
  if (typeof detail === 'object' && detail !== null && detail.msg) {
    return detail.msg;
  }
  
  // Handle string details
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Fallback to error message or default
  return error?.message || defaultMessage;
};
